$(() => {

    'use strict';

    /*============================================
        Initializations
    ==============================================*/

    // AJAX
    require('./modules/ajax.js');

    // Bootstrap
    require('./modules/bootstrap.js');

    /*============================================
        Event Listeners
    ==============================================*/

    // Unused links
    $(document).on('click', 'a[href="#"]', function (e) {
        e.preventDefault();
    });

    // Preloader
    $(window).on('load', function () {
        $(window).trigger('scroll');
        $('body').attr('data-loaded', true);
    });

    setTimeout(() => {
        $('body').attr('data-loaded', true);
    }, 1500);

    // Locale
    $(document).on('click', '[data-event="locale"]', function () {
        $.ajax({
            type: 'POST',
            url: "/locale",
            data: {
                'locale': $(this).data('locale'),
            },
            success: function (e) {
                $.handleSuccess(e, () => {
                    $.redirectTo(e.data.next);
                });
            },
            error: function (e) {
                $.handleError(e);
            },
        });
    });
});
